/**
 * Safely creates a Date object from a date string without timezone conversion issues.
 * 
 * When creating Date objects from strings like "2025-09-07", JavaScript interprets them
 * as local time and can shift the date when converting to UTC. This function ensures
 * the date stays consistent by setting the time to noon UTC.
 * 
 * @param {string} dateString - Date string in format YYYY-MM-DD (e.g., "2025-09-07")
 * @returns {Date} Date object set to noon UTC
 */
export const createSafeDateFromString = (dateString) => {
  // For strings like "2025-09-07", add time component to avoid timezone shifts
  return new Date(`${dateString}T12:00:00Z`);
};

/**
 * Safely creates a Date object from year, month, and day without timezone conversion issues.
 * 
 * @param {number} year - The year (e.g., 2025)
 * @param {number} month - The month (1-12, where 1 is January)
 * @param {number} day - The day of the month (1-31)
 * @returns {Date} Date object set to noon UTC
 */
export const createSafeDateFromComponents = (year, month = 1, day = 1) => {
  // Convert month to 0-indexed for Date constructor
  const monthIndex = month - 1;
  // Create UTC date at noon
  return new Date(Date.UTC(year, monthIndex, day, 12, 0, 0));
};

